<script lang="ts" setup>
import { Notification } from '@/Support/Communications/Classes/Notification'
import NotificationBanner from '@/Components/App/Communications/NotificationBanner.vue'
import { storeToRefs } from 'pinia'
import { useNotifications } from '@/stores/notifications'
import { t } from '@/Support/lang'
import { useAlertModal } from '@/stores/alertModal'
import { NotificationData } from '@/Support/Communications/Interfaces/NotificationData'
import { ref } from 'vue'

const notifications = useNotifications()
const { loadNotifications } = notifications
const { notificationData } = storeToRefs(notifications)
const { newPromptWarningAlert } = useAlertModal()
const banner = ref<InstanceType<typeof NotificationBanner> | null>(null)

const visit = (data: NotificationData) => {
  const notification = new Notification(data)
  notification.visitUrl(undefined, {
    onFinish: () => {
      loadNotifications()
      banner.value?.closeNotification()
    },
  })
}

const see = () => {
  const data = notificationData.value
  if (!data || !data.url) {
    return
  }

  if (data.confirmation) {
    const confirmationLabel =
      data.confirmation_label ||
      t('Are you sure you want to perform the following action: :action?', {
        action: data.url_label_button,
      })
    newPromptWarningAlert(
      'Please confirm',
      confirmationLabel,
      t("Yes, I'm sure"),
      () => visit(data),
    )
  } else {
    visit(data)
  }
}
</script>
<template>
  <NotificationBanner ref="banner" @click="see" />
</template>
